export default "__VITE_ASSET__BHmqC5YL__"